module.exports = __webpack_public_path__ + "img/3832b98.png";